import { Toaster as SonnerToaster, toast } from 'sonner';
import { useThemeStore } from '../store/theme';

export { toast };

/**
 * App-wide toast outlet (replaces antd `notification`/`message`).
 * Mount once near the app root. Use `toast.success(...)`, `toast.error(...)`,
 * `toast(title, { description })`. Themed to the Green Bay surface tokens.
 */
export function Toaster() {
  const isDark = useThemeStore((s) => s.resolved)() === 'dark';
  return (
    <SonnerToaster
      position="top-right"
      theme={isDark ? 'dark' : 'light'}
      gap={10}
      toastOptions={{
        classNames: {
          toast: 'gb-toast rounded-card! border! border-line! bg-surface! text-content! shadow-pop!',
          title: 'font-semibold! text-content!',
          description: 'text-muted!',
          actionButton: 'bg-brand-600! text-white!',
          cancelButton: 'bg-surface-2! text-muted!',
          closeButton: 'bg-surface! border-line! text-muted!',
        },
      }}
    />
  );
}
